import { DrillDesignFactorBase } from './base/drill-design-factor-base';

export class DrillDesignFactor extends DrillDesignFactorBase { }